var _polygon, _polygon2, _g, _g2, _path, _polygon3, _path2, _g3, _path3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorrrrkıds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300.49 510.52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "112.06 49.58 112.06 49.45 35.4 49.45 35.4 72.38 112.19 72.38 112.19 49.45 112.06 49.45 112.06 49.58 111.94 49.58 111.94 72.13 35.65 72.13 35.65 49.7 112.06 49.7 112.06 49.58 111.94 49.58",
    fill: "#1e1e1c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.72 255.41 147.42 255.41 147.42 255.41 0.32 255.41 0.02 255.41 0.02 255.11 0.32 255.11 0.32 255.11 147.42 255.11 147.72 255.11",
    fill: "#e1261d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e30a18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.84 235.42v0.13c1.14 0 2.17 0.46 2.92 1.21s1.21 1.78 1.21 2.92-0.46 2.17-1.21 2.92-1.78 1.21-2.92 1.21-2.17-0.46-2.92-1.21-1.21-1.78-1.21-2.92 0.46-2.17 1.21-2.92 1.78-1.21 2.92-1.21v-0.25c-2.42 0-4.38 1.96-4.38 4.38s1.96 4.38 4.38 4.38 4.38-1.96 4.38-4.38-1.96-4.38-4.38-4.38v0.13z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.54 255.26 147.54 255.12 0.28 255.12 0.28 0.28 147.4 0.28 147.4 255.26 147.54 255.26 147.54 255.12 147.54 255.26 147.69 255.26 147.69 0 0 0 0 255.4 147.69 255.4 147.69 255.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.65 275.1v-0.13c-1.14 0-2.17-0.46-2.92-1.21s-1.21-1.78-1.21-2.92 0.46-2.17 1.21-2.92 1.78-1.21 2.92-1.21c2.28 0 4.12 1.84 4.13 4.13 0 1.14-0.46 2.17-1.21 2.92s-1.78 1.21-2.92 1.21v0.25c2.42 0 4.38-1.96 4.38-4.38s-1.96-4.37-4.38-4.38c-2.42 0-4.38 1.96-4.38 4.38s1.96 4.38 4.38 4.38v-0.13z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.95 255.26 152.95 255.4 300.21 255.4 300.21 510.24 153.09 510.24 153.09 255.26 152.95 255.26 152.95 255.4 152.95 255.26 152.81 255.26 152.81 510.52 300.49 510.52 300.49 255.12 152.81 255.12 152.81 255.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.65 235.42v0.13c1.14 0 2.17 0.46 2.92 1.21s1.21 1.78 1.21 2.92-0.46 2.17-1.21 2.92-1.78 1.21-2.92 1.21-2.17-0.46-2.92-1.21-1.21-1.78-1.21-2.92 0.46-2.17 1.21-2.92 1.78-1.21 2.92-1.21v-0.25c-2.42 0-4.38 1.96-4.38 4.38s1.96 4.38 4.38 4.38 4.38-1.96 4.38-4.38-1.96-4.38-4.38-4.38v0.13z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.35 255.26 300.35 255.12 153.09 255.12 153.09 0.28 300.21 0.28 300.21 255.26 300.35 255.26 300.35 255.12 300.35 255.26 300.49 255.26 300.49 0 152.81 0 152.81 255.4 300.49 255.4 300.49 255.26"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1d1d1b"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11.84 129.5 11.84 129.65 135.51 129.65 135.51 164.53 11.99 164.53 11.99 129.5 11.84 129.5 11.84 129.65 11.84 129.5 11.69 129.5 11.69 164.83 135.81 164.83 135.81 129.35 11.69 129.35 11.69 129.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "135.75 150.71 11.83 150.71 11.83 151.01 135.75 151.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "135.93 150.99 12.02 150.99 12.02 151.29 135.93 151.29"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(134.23 159.19) rotate(180)",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: "4.5px",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MEDID"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.5,
    y: 0,
    letterSpacing: "-.04em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.58,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 19.31,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.56,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 22.29,
    y: 0,
    letterSpacing: "-.07em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.7,
    y: 0
  }, "AMANHO"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.95,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 46.68,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.93,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 49.66,
    y: 0
  }, "SIZE"), /*#__PURE__*/React.createElement("tspan", {
    x: 59.66,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 61.39,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.64,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 64.36,
    y: 0,
    letterSpacing: "-.07em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 66.78,
    y: 0
  }, "AILLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 79.78,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 81.5,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.76,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 84.48,
    y: 0
  }, "MA"), /*#__PURE__*/React.createElement("tspan", {
    x: 91.48,
    y: 0,
    letterSpacing: "-.07em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 94.4,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.15,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 98.87,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 100.12,
    y: 0,
    letterSpacing: ".11em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 101.85,
    y: 0
  }, "MISURE/")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(134.23 153.69) rotate(180)",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: "4.5px",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GR\xD3SE"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.25,
    y: 0,
    letterSpacing: ".47em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 19.63,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.88,
    y: 0,
    letterSpacing: ".47em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 24.25,
    y: 0
  }, "METPO"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.25,
    y: 0,
    letterSpacing: ".47em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 43.63,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.88,
    y: 0,
    letterSpacing: ".47em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 48.25,
    y: 0
  }, "BEDEN"), /*#__PURE__*/React.createElement("tspan", {
    x: 64,
    y: 0,
    letterSpacing: ".47em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 67.38,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.63,
    y: 0,
    letterSpacing: ".47em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 72,
    y: 0
  }, "ROZMIAR"), /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    y: 0,
    letterSpacing: ".47em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 96.37,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.62,
    y: 0,
    letterSpacing: ".47em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 101,
    y: 0
  }, "MASURA")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(93.04 10.92) rotate(180)",
    fontFamily: "ZaraH1Sans-Regular, 'Zara H1 Sans'",
    fontSize: "6px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "zarahom"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.83,
    y: 0,
    letterSpacing: "-.02em"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.77,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 27.08,
    y: 0,
    letterSpacing: "-.02em"
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.72,
    y: 0
  }, "om")), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.94,24.4c-.2-.04-.4-.07-.6-.12-.96-.21-1.8-.65-2.5-1.35l-.03-.03c-.31.3-.62.61-.93.91l-.03-.02c.02-.94.03-1.88.05-2.83.94.02,1.88.03,2.82.05-.33.31-.65.62-.98.94.14.12.24.22.34.3.76.59,1.63.83,2.58.82,1.48-.02,2.77-.59,3.93-1.46.52-.4.98-.85,1.39-1.36l.07-.08c.32.33.63.66.95,1l-.1.12c-.98,1.12-2.12,2.02-3.51,2.57-.67.27-1.37.44-2.09.53l-.23.03c-.38,0-.75-.01-1.13-.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.8,16.99c-.02.12-.05.25-.07.39l-.08-.07c-.37-.39-.74-.78-1.11-1.17l-.07-.17c-.03-.17-.04-.34-.07-.55l.11.1c.4.41.81.83,1.21,1.25l.09.08v.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.42,18.61c.02-.12.04-.24.07-.38l.08.08c.36.37.72.74,1.07,1.12l.08.18c.02.15.03.31.06.49l-.1-.1c-.39-.4-.78-.81-1.18-1.22l-.09-.08v-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,21.32c-.24-.13-.47-.25-.69-.37l-.03-.03c.25-.37.5-.73.75-1.1-.1-.12-.19-.23-.3-.35-.21.34-.41.68-.62,1.03-.26-.12-.51-.24-.77-.36.44-.58.87-1.16,1.32-1.77-.2.01-.37.02-.56.03.03.13.06.25.09.38-.21.06-.42.11-.64.17-.14-.37-.28-.73-.42-1.09h-.02c-.02.99-.03,1.99-.05,2.98-.28.01-.54.03-.8.03-.73.03-1.46.13-2.18.27l-.11-.04c-.11-.32-.22-.64-.34-.98.11-.03.21-.05.31-.07.19-.03.38-.04.56-.07l.1-.08c.02-.36.04-.71.06-1.07v-.04c-.35,0-.68.01-1.03.03,0-.33.01-.65.02-1,.33,0,.67.01,1.03.02-.03-.33-.05-.62-.09-.92-.03-.24-.09-.48-.14-.71l-.12-.19-.16.16c-.07.13-.12.27-.19.41l-.04-.09c-.11-.27-.22-.54-.33-.8l-.03-.25c.06-.25.14-.48.28-.68.28-.41.72-.45,1.06-.09.25.27.38.61.43.97.09.69.15,1.37.22,2.06l.02.19c.19,0,.38,0,.58.01.01-.68.02-1.36.03-2.05-.22.04-.42.08-.64.12,0-.34-.01-.68-.02-1.03.7-.13,1.39-.26,2.1-.39,0,.32-.01.64-.02.96.12-.02.22-.03.32-.04.06.54.12,1.07.17,1.62-.19.03-.37.05-.57.07-.08-.48-.17-.95-.25-1.42h-.15c0,.56-.02,1.12-.03,1.7.23-.05.45-.09.68-.14l.08.23c.12-.01.24-.03.38-.04.01-.98.03-1.96.04-2.95.31,0,.6,0,.9.01-.01.95-.03,1.91-.04,2.87.34-.01.68-.03,1.04-.04,0,.32-.01.63-.02.96-.12,0-.25,0-.38,0l-.15.07c-.1.09-.18.2-.28.3.29.32.58.64.88.96-.16.26-.33.53-.49.8l-.19-.11c-.18.31-.37.63-.56.95M214.38,19.95c0-.38.01-.74.02-1.11-.19.01-.36.02-.54.02,0,.36-.01.72-.02,1.08.18,0,.36,0,.54,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.15,15.39c-.31-.33-.6-.65-.91-1,.19-.21.4-.44.61-.66.99-1,2.14-1.75,3.49-2.2.62-.2,1.25-.32,1.9-.36,1.04-.06,2.03.12,2.97.6.42.22.8.5,1.14.83l.1.09c.31-.29.61-.59.93-.9-.01.95-.03,1.89-.04,2.83-.94-.02-1.88-.03-2.81-.04.32-.31.64-.62.97-.94-.26-.27-.52-.48-.82-.64-.74-.42-1.55-.56-2.39-.5-1.85.15-3.35,1.01-4.62,2.32-.17.18-.32.36-.5.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.89,14.98c.23.14.44.27.64.4l.04.09c-.15.53-.17,1.08-.24,1.63l-.11.08c-.19-.02-.38-.04-.58-.05,0-.73.04-1.44.25-2.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7,19.18c.33.33.66.66.99.99-.17.25-.34.5-.52.76-.32-.34-.63-.67-.94-1.01.16-.26.32-.51.47-.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.52,16.35c-.33-.32-.65-.64-.97-.96.17-.25.34-.49.5-.72.31.31.62.62.93.93-.15.25-.31.5-.46.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.16,18.14c.2.2.39.39.57.58.13.14.27.28.4.42l.02.1c-.09.21-.2.41-.3.62l-.08-.07c-.28-.3-.57-.59-.85-.89l-.03-.15c.09-.2.17-.4.26-.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.37,15.71c.19.19.38.38.57.57.12.12.24.24.35.37l.04.11c-.09.22-.18.44-.28.67l-.1-.11c-.27-.31-.55-.61-.83-.92l-.02-.16c.09-.18.18-.36.27-.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.45,16.95c.38.39.74.76,1.1,1.13l.02.09c-.05.16-.1.32-.15.47l-.04.03-.09-.14c-.29-.3-.59-.61-.89-.91l-.05-.17c.04-.16.06-.32.1-.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.75,18.59l-.08-.08c-.32-.33-.64-.67-.96-1l-.03-.16c.06-.15.1-.29.16-.45l.09.09c.29.32.58.63.88.95l.05.18c-.03.15-.06.31-.09.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.26 25.1v-14.15h1.55v6.25h1.59v-6.26h1.58v14.15h-4.72zm1.59-1.6h1.54v-4.69h-1.54v4.69z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.55 25.1 194.55 23.54 196.11 23.54 196.11 18.81 194.58 18.81 194.58 17.24 196.11 17.24 196.11 12.5 194.57 12.5 194.57 10.93 197.7 10.93 197.7 25.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.53 10.93 186.68 10.93 186.68 25.1 183.53 25.1 183.53 23.52 185.09 23.52 185.09 12.5 183.53 12.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167,15.62l-1.22,1.18-.02-.59h-1.05s-1.05.01-1.05.01l-.18.06c-.1.03-.23.1-.3.14-.38.27-.47.75-.24,1.27.03.07.38.69.78,1.38.39.68.71,1.25.7,1.26l-.94.53s-.33-.57-.72-1.24c-.79-1.37-.86-1.5-.97-1.81-.41-1.22.08-2.21,1.26-2.55.36-.1.4-.11,1.57-.12h1.13s.02-.7.02-.7l1.23,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07,15.16c.77.14,1.33.5,1.59,1.04.11.23.15.39.16.7.01.32-.02.54-.14.89-.1.29-.22.53-.68,1.33-.21.37-.39.67-.38.67l.51.31-1.63.46-.4-1.64.58.27c.07-.09.83-1.43.88-1.54.09-.19.13-.39.11-.58-.02-.4-.24-.67-.67-.81l-.17-.06h-1.56s-1.56-.01-1.56-.01v-1.08h1.57c1.41,0,1.6,0,1.8.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.51,21.64s-1.33,2.37-1.51,2.63c-.2.29-.5.59-.74.76-.15.1-.44.23-.63.28-.48.12-1.03,0-1.47-.33-.22-.16-.54-.51-.71-.76-.08-.12-.33-.54-.55-.92-.22-.39-.41-.71-.41-.71l-.53.28.41-1.64,1.62.46-.54.35s.84,1.47.94,1.61c.26.37.64.56.99.49.27-.05.53-.24.71-.5.05-.07.4-.66.78-1.32s.71-1.2.72-1.21c.31.16.63.33.92.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,18.25v-.51h1.97v.38l-.7.75c-.48.52-.56.66-.56.9s.17.41.49.41c.34,0,.58-.13.7-.24h0v.61c-.14.08-.41.19-.79.19-.65,0-1.06-.38-1.06-.91,0-.42.17-.71.7-1.23l.35-.35h-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.21,18.25v-.51h1.97v.38l-.7.75c-.48.52-.56.66-.56.9s.17.41.49.41c.34,0,.58-.13.7-.24h0v.61c-.14.08-.41.19-.79.19-.65,0-1.06-.38-1.06-.91,0-.42.17-.71.7-1.23l.35-.35h-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,13.17c-.15.03-.36.05-.64.05-.31,0-.53-.07-.68-.19-.14-.11-.23-.29-.23-.51s.07-.4.2-.52c.17-.17.43-.24.73-.24h.21s0-.85,0-.85h.42v2.26ZM169.69,12.11l-.21-.02c-.31,0-.51.15-.51.42,0,.26.18.39.47.39.12,0,.2-.01.24-.02v-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.82,11.56l.2-.65h.43l-.74,2.29h-.53l-.75-2.29h.45l.21.65h.73ZM167.16,11.88l.18.57c.04.14.08.3.12.43h0c.03-.13.07-.29.11-.43l.18-.57h-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.95,13.17c-.15.03-.36.05-.64.05-.31,0-.53-.07-.68-.19-.14-.11-.23-.29-.23-.51s.07-.4.2-.52c.17-.17.43-.24.73-.24h.21s0-.85,0-.85h.42v2.26ZM165.53,12.11l-.21-.02c-.31,0-.51.15-.51.42,0,.26.18.39.47.39.12,0,.2-.01.24-.02v-.78Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.25 275.1v-0.13c-1.14 0-2.17-0.46-2.92-1.21s-1.21-1.78-1.21-2.92 0.46-2.17 1.21-2.92 1.78-1.21 2.92-1.21c2.28 0 4.12 1.84 4.13 4.13 0 1.14-0.46 2.17-1.21 2.92s-1.78 1.21-2.92 1.21v0.25c2.42 0 4.38-1.96 4.38-4.38s-1.96-4.37-4.38-4.38c-2.42 0-4.38 1.96-4.38 4.38s1.96 4.38 4.38 4.38v-0.13z",
    fill: "#e30a18"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "0.14 255.26 0.14 255.4 147.4 255.4 147.4 510.24 0.28 510.24 0.28 255.26 0.14 255.26 0.14 255.4 0.14 255.26 0 255.26 0 510.52 147.69 510.52 147.69 255.12 0 255.12 0 255.26",
    fill: "#e30a18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.98,7.74c5.11,0,9.26,4.11,9.26,9.15v17.62h-52.13c-5.11,0-9.26-4.11-9.26-9.15V7.74h52.13Z",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#010202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m239.71 28.22h30.19v-11.31c0-3.84-3.18-6.97-7.08-6.97h-30.19v11.31c0 3.84 3.18 6.97 7.08 6.97m23.11-17.58c3.52 0 6.37 2.81 6.37 6.27v10.6h-29.49c-3.52 0-6.38-2.81-6.38-6.27v-10.61h29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,32.28h4.22c.77,0,1.41-.63,1.41-1.41v-3.36h-7.03v3.36c0,.77.63,1.41,1.41,1.41h-.01ZM266.66,31.01h.95v-.81h-.76v-.57h.76v-1.42h.66v3.36h-1.61v-.56ZM265.1,28.22l.34,1.33h.22v-1.33h.66v3.36h-.97c-.56,0-.91-.31-.91-.99,0-.48.16-.76.39-.89l-.43-1.48h.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.43,31.02h.24v-.98h-.25c-.19,0-.3.13-.3.5,0,.31.1.48.31.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.33,10.64v10.61c0,3.46,2.86,6.27,6.37,6.27h13.1l-4.51-7.66,4.51-9.22h-19.47ZM237.34,12.53c0-.29.24-.52.52-.52h.45c.22,0,.4.13.48.32.16-.2.41-.32.68-.32h4.87c.28,0,.52.12.68.32.08-.19.27-.32.48-.32h.45c.29,0,.52.24.52.52v1.89c0,.29-.24.52-.52.52h-.56c.21,2.32.53,5.91.69,7.54.02.17-.11.31-.27.33-.17.02-.31-.11-.33-.27-.24-2.5-.88-9.64-.88-9.71-.01-.12-.13-.22-.27-.22h-4.87c-.14,0-.25.1-.27.22,0,.07-.64,7.21-.88,9.71-.02.17-.16.29-.33.27-.17-.02-.29-.16-.27-.33.16-1.63.48-5.22.69-7.55h-.11s-.45.01-.45.01c-.29,0-.52-.24-.52-.52v-1.89h.02ZM242.31,21.55c.12.12.12.3,0,.42-.12.12-.3.12-.42,0l-.93-.93c-.12-.12-.12-.3,0-.42l.93-.93.21-.09.21.09c.12.12.12.3,0,.42l-.42.42h.02c1.14,0,2.06-.92,2.06-2.06s-.92-2.06-2.06-2.06-2.06.92-2.06,2.06c0,.27.05.54.16.79.06.15-.01.33-.16.39s-.33,0-.39-.16c-.13-.32-.2-.67-.2-1.02,0-1.46,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66-1.19,2.66-2.66,2.66h-.03l.43.43h-.01ZM246.87,24.61c0,.35-.27.63-.6.63h-.52l-.71.62c-.15.13-.38.21-.62.21h-5.01c-.24,0-.47-.08-.62-.21l-.71-.62h-.52c-.33,0-.6-.28-.6-.63v-.8c0-.11.03-.22.08-.32l.09-.1c.1-.06.21-.1.32-.1h8.91c.11,0,.23.03.32.1l.1.1c.05.1.08.21.08.32v.8h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.55,24.61v.04h.63l.19.07.79.69s.12.06.23.06h5.01c.11,0,.2-.03.23-.06l.79-.69.19-.07h.63v-.04s.01-.73.01-.73h-8.73v.73h.03ZM239.41,24.71h5.01c.14,0,.25.11.25.25s-.11.25-.25.25h-5.01c-.14,0-.25-.11-.25-.25s.11-.25.25-.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.17,19.25c.76-1.11.11-2.57-.67-3.31-.71-.67-1.28-.83-1.36-.85l-.36.69-1.05-2.86,2.96-.6-.39.73.4.23c1.25.81,1.51,1.91,1.6,2.26.15.59.37,2.37-1.13,3.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,19.2c-.54-1.23-2.12-1.47-3.16-1.2-.92.23-1.36.62-1.44.68l.4.69-2.98-.65,1.08-2.82.4.71.39-.21c1.35-.62,2.42-.25,2.76-.14.58.19,2.2.95,2.55,2.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.92,22.18c.21-1.47,1.09-2.18,1.37-2.4.47-.39,1.99-1.34,3.85-.56-1.33-.21-2.38.99-2.72,2.01-.31.91-.22,1.49-.2,1.58l.79.04-2.15,2.16-1.8-2.43.81.05.03-.45h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.95,23.42c.68,0,1.23.55,1.23,1.23s-.55,1.23-1.23,1.23-1.23-.55-1.23-1.23.55-1.23,1.23-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.85,17.44c-.11.29-.26.27-.26.27,0,0-.14.03-.22-.26l-1.15-4.03c.96.28,1.83.75,2.58,1.38l-.94,2.64h-.01ZM281.27,28.22c4.44,0,8.05-3.61,8.05-8.05s-3.61-8.05-8.05-8.05c-.24,0-.47.01-.7.04l-.05-.81-1.47,1.42,1.65,1.26-.06-.85c.21-.02.43-.03.64-.03.34,0,.68.03,1,.07l.03.21.76,6.52c.11,1.23-.6,1.43-1.03,1.24l-2.44-.98c-.28-.12-.41.11-.41.11,0,0-.16.24.12.43,0,0,3.33,2.2,4.04,2.34.97.18,1.92-.6,2.14-1.62l1.18-5.79c1.02,1.22,1.63,2.79,1.63,4.49,0,3.87-3.15,7.02-7.02,7.02-2.07,0-3.93-.9-5.22-2.33l-.72.73c1.47,1.61,3.59,2.62,5.94,2.62"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.53,16.88l5.02,6.06c.21.25.62.47.94.51l2.52.27h.12l.77,1.7c.06.13.21.19.34.13l.13-.14v-.2l-.71-1.56h.02l1.01,1.21c.09.11.26.12.36.03.11-.09.12-.25.03-.36l-1.04-1.26c.07-.16.11-.36.12-.52l.16-2.49c.02-.32-.12-.77-.33-1.01l-5.02-6.06c-.14-.17-.34-.26-.56-.26-.17,0-.33.06-.46.17l-3.33,2.76c-.15.12-.24.3-.26.49-.02.19.04.38.16.53h.01ZM264.65,22.78l-.59-.72c.1-.16.17-.34.19-.54.03-.32-.07-.64-.27-.88-.23-.28-.57-.44-.93-.44-.28,0-.55.1-.77.28-.51.43-.58,1.19-.16,1.7.23.28.57.44.93.44.23,0,.45-.07.64-.19l.6.72h-.01l-.11.02-.04.03h-.06l-2.52-.27c-.19-.02-.48-.17-.6-.32l-5.02-6.06c-.08-.09-.06-.23.03-.3l3.33-2.76.14-.05.17.08,5.02,6.06c.12.15.22.46.21.65l-.16,2.48v.07h-.02ZM263.67,21.6l-.2-.09-.16.06c-.11.09-.12.25-.03.36l.08.1c-.1.05-.2.08-.31.08-.21,0-.4-.09-.54-.25-.24-.29-.2-.73.09-.98.12-.1.28-.16.44-.16.21,0,.4.09.54.25.16.19.19.45.12.67l-.03-.04Z",
    fill: "#1e1e1d"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#010202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.19,24.65l.19.07.79.69s.12.06.23.06h5.01c.11,0,.2-.03.23-.06l.79-.69.19-.07h.63v-.04s0-.73,0-.73h-8.73v.77h.66ZM239.41,24.71h5.01c.14,0,.25.11.25.25s-.11.25-.25.25h-5.01c-.14,0-.25-.11-.25-.25s.11-.25.25-.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.71,28.22h14.33l-4.95-8.39,4.84-9.89h-21.3v11.31c0,3.84,3.18,6.97,7.08,6.97M237.34,12.53c0-.29.24-.52.52-.52h.45c.22,0,.4.13.48.32.16-.2.41-.32.68-.32h4.87c.28,0,.52.12.68.32.08-.19.27-.32.48-.32h.45c.29,0,.52.24.52.52v1.89c0,.29-.24.52-.52.52h-.56c.21,2.32.53,5.91.69,7.54.02.17-.11.31-.27.33-.17.02-.31-.11-.33-.27-.24-2.5-.88-9.64-.88-9.71-.01-.12-.13-.22-.27-.22h-4.87c-.14,0-.25.1-.27.22,0,.07-.64,7.21-.88,9.71-.02.17-.16.29-.33.27-.17-.02-.29-.16-.27-.33.16-1.63.48-5.22.69-7.55h-.11s-.45.01-.45.01c-.29,0-.52-.24-.52-.52v-1.89h.02ZM242.31,21.55c.12.12.12.3,0,.42s-.3.12-.42,0l-.93-.93c-.12-.12-.12-.3,0-.42l.93-.93.21-.09.21.09c.12.12.12.3,0,.42l-.42.42h.02c1.14,0,2.06-.92,2.06-2.06s-.92-2.06-2.06-2.06-2.06.92-2.06,2.06c0,.27.05.54.16.79.06.15-.01.33-.16.39s-.33,0-.39-.16c-.13-.32-.2-.67-.2-1.02,0-1.46,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66-1.19,2.66-2.66,2.66h-.03l.43.43h-.01ZM236.96,23.82c0-.11.03-.22.08-.32l.09-.1c.1-.06.21-.1.32-.1h8.91c.11,0,.23.03.32.1l.1.1c.05.1.08.21.08.32v.8c0,.35-.27.63-.6.63h-.52l-.71.62c-.15.13-.38.21-.62.21h-5.01c-.24,0-.47-.08-.62-.21l-.71-.62h-.52c-.33,0-.6-.28-.6-.63v-.8h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.34,32.28h4.22c.77,0,1.41-.63,1.41-1.41v-3.36h-7.03v3.36c0,.77.63,1.41,1.41,1.41h0ZM258.71,28.22h1.92v3.36h-1.88v-.55h1.2v-.79h-1.13v-.55h1.13v-.9h-1.25v-.57ZM257.44,28.15c.35,0,.62.08.8.23.18.15.27.41.27.78v.1h-.68v-.09c0-.18-.03-.31-.1-.4-.07-.08-.18-.13-.35-.13-.12,0-.22.04-.29.11-.08.07-.11.17-.11.31,0,.1.02.19.05.26.04.07.11.13.23.18.4.16.65.27.74.32.1.05.18.12.24.19s.12.16.16.27c.04.1.06.22.06.37,0,.32-.09.56-.27.73-.18.17-.44.25-.77.25s-.59-.08-.77-.23c-.18-.15-.27-.38-.27-.69v-.08h.65c0,.33.12.5.37.5s.39-.13.39-.39c0-.12-.03-.22-.08-.28-.05-.06-.14-.12-.27-.18l-.52-.23c-.23-.09-.39-.21-.49-.35-.1-.14-.15-.32-.15-.54,0-.69.39-1.03,1.17-1.03v.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorrrrkıds);
export default __webpack_public_path__ + "static/media/VECTORRRRKIDS.63b62df653b781d333585e8665e47e2c.svg";
export { ForwardRef as ReactComponent };